// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__b2RgK","title":"styles_title__Dzs1D"};
module.exports.__checksum = "54696172d3bf"